import { render } from "./StepFive.vue?vue&type=template&id=3c286c6c"
import script from "./StepFive.vue?vue&type=script&lang=js"
export * from "./StepFive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__